import { type SvgProps, SvgWrapper } from '../utils';
export function FilterListIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M22 4.25C22.4142 4.25 22.75 4.58579 22.75 5C22.75 5.41421 22.4142 5.75 22 5.75H2C1.58579 5.75 1.25 5.41421 1.25 5C1.25 4.58579 1.58579 4.25 2 4.25H22Z" />
      <path d="M18 11.25C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75H6C5.58579 12.75 5.25 12.4142 5.25 12C5.25 11.5858 5.58579 11.25 6 11.25H18Z" />
      <path d="M15 18.25C15.4142 18.25 15.75 18.5858 15.75 19C15.75 19.4142 15.4142 19.75 15 19.75H9C8.58579 19.75 8.25 19.4142 8.25 19C8.25 18.5858 8.58579 18.25 9 18.25H15Z" />
    </SvgWrapper>
  );
}
